import PointMedium from '../FaceShape/PointMedium'
import PointWide from '../FaceShape/PointWide'
import RoundNarrow from '../FaceShape/RoundNarrow'
import SquareMedium from '../FaceShape/SquareMedium'
import SquareWide from '../FaceShape/SquareWide'
import PointNarrow from '../FaceShape/PointNarrow'
import RoundMedium from '../FaceShape/RoundMedium'
import RoundWide from '../FaceShape/RoundWide'
import SquareNarrow from '../FaceShape/SquareNarrow'

const headY = 60

const data = [
  {
    id: 'pointMedium',
    svg: PointMedium,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'pointWide',
    svg: PointWide,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'roundNarrow',
    svg: RoundNarrow,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'squareMedium',
    svg: SquareMedium,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'pointNarrow',
    svg: PointNarrow,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'roundMedium',
    svg: RoundMedium,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'roundWide',
    svg: RoundWide,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'squareNarrow',
    svg: SquareNarrow,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
  {
    id: 'squareWide',
    svg: SquareWide,
    positioning: {
      y: headY,
      scaleX: 1,
    },
  },
]

export default data
